import { render, staticRenderFns } from "./BlackHoleStateRow.vue?vue&type=template&id=d6d66fce&scoped=true"
import script from "./BlackHoleStateRow.vue?vue&type=script&lang=js"
export * from "./BlackHoleStateRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d66fce",
  null
  
)

export default component.exports